function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".binoculars_svg__cls-1{fill:#fff}"));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "binoculars_svg__cls-1",
  d: "M49.17 179.2a16.61 16.61 0 01-7.62-22.2 5.14 5.14 0 10-9.24-4.52 26.94 26.94 0 0012.34 36 5.14 5.14 0 104.52-9.24zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "binoculars_svg__cls-1",
  d: "M293.73 139.29a57 57 0 00-11.75-16s-38.39-48.84-50.66-65.54c-11.23-15.28-30.4-22.71-47.75-14.23A36.85 36.85 0 00165.49 90l5.41 21h-42.71l5.4-21a36.83 36.83 0 00-18.08-46.42c-17.34-8.48-36.27-.88-47.72 14.23-13.73 18.1-50.67 65.54-50.67 65.54a57.23 57.23 0 00-11.77 16 56.91 56.91 0 0051.09 81.89A56.58 56.58 0 00112.27 175l29 12.88a20.34 20.34 0 0016.53 0l29-12.88a56.86 56.86 0 10106.91-35.72zm-204.64 41a36.32 36.32 0 11-16.66-48.58 36.12 36.12 0 0116.66 48.58zM149.54 162a14.14 14.14 0 1114.14-14.14A14.15 14.15 0 01149.54 162zM277 176.06a36.31 36.31 0 11-1.72-27.73 36 36 0 011.72 27.73zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "binoculars_svg__cls-1",
  d: "M259.9 150.11a5.15 5.15 0 00-2.36 6.88 16.61 16.61 0 01-7.62 22.21 5.14 5.14 0 004.52 9.24 26.93 26.93 0 0012.34-36 5.14 5.14 0 00-6.88-2.36zm0 0"
});

var SvgBinoculars = function SvgBinoculars(props) {
  return React.createElement("svg", _extends({
    id: "binoculars_svg__Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 300 300"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgBinoculars;